import React from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  Typography,
  Divider,
  Paper,
  Grid,
} from "@mui/material";
import CustomMaterialHelpListItem from "./CustomMaterialHelpListItem/CustomMaterialHelpListItem";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DateRangeIcon from "@mui/icons-material/DateRange";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { Timestamp } from "@firebase/firestore";

function MaterialHelpEntry({ entry }) {
  const { provider, when, where, provides, logo } = entry;
  const dateObj = new Timestamp(when.seconds, when.nanoseconds).toDate();
  const date = `${dateObj.toLocaleDateString().replace(/[ ]/g, "")}`;
  return (
    <Paper
      elevation={3}
      sx={{
        padding: "20px",
        boxShadow: "5px 5px 20px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 25%), 0px 1px 8px 0px rgb(0 0 0 / 22%)"
      }}>
      <List>
        <ListItem
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap-reverse",
          }}
        >
          <Typography sx={{ fontSize: "2.5rem", fontWeight: 400 }}>
            {provider}
          </Typography>
          <ListItemAvatar>
            <img
              src={logo}
              alt={"logo_img"}
              style={{ maxWidth: "100px", maxHeight: "150px" }}
            />
          </ListItemAvatar>
        </ListItem>
        <Divider />
        <Grid container>
          <Grid item xs={12} xl={6}>
            <CustomMaterialHelpListItem
              icon={<DateRangeIcon />}
              text={"Kedy?"}
              emphasizedInfoAfterText={date}
            />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CustomMaterialHelpListItem
              icon={<LocationOnIcon />}
              text={"Kde?"}
              emphasizedInfoAfterText={where}
            />
          </Grid>
        </Grid>
        <CustomMaterialHelpListItem
          icon={<HelpCenterIcon />}
          emphasizedInfoBeforeText={"Ponúkaná pomoc:"}
          text={provides}
        />
      </List>
    </Paper>
  );
}

export default MaterialHelpEntry;
